'use strict';

exports.__esModule = true;
exports.SpecialistReviewsContainer = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _style = require('../../src/styles/style.scss');

var _style2 = _interopRequireDefault(_style);

var _review = require('review');

var _widgetCarousel = require('widget-carousel');

var _peerRecommendation = require('peer-recommendation');

var _reactTransitionGroup = require('react-transition-group');

var _constants = require('../utils/constants');

var _utils = require('../utils/utils');

var _reactAnimations = require('react-animations');

var _radium = require('radium');

var _radium2 = _interopRequireDefault(_radium);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dynamics = {
	fadeIn: {
		animation: 'x 1s',
		animationName: _radium2.default.keyframes(_reactAnimations.fadeIn, 'fadeIn')
	}
};

var _ref = _react2.default.createElement(
	'div',
	{ key: 'no specialist to show' },
	'No Practice reviews to show'
);

var _ref2 = _react2.default.createElement(
	'div',
	{ key: 'no specialist to show' },
	'No Practice reviews to show'
);

var SpecialistReviewsContainer = exports.SpecialistReviewsContainer = function SpecialistReviewsContainer(props) {
	if (!props.widget || !props.header || !props.carousel) {
		throw new Error('Missing one reducer!');
	}
	return _react2.default.createElement(
		_radium.StyleRoot,
		null,
		_react2.default.createElement(
			'div',
			{ className: _style2.default.widgetCarousel + ' ' + (props.widget && props.widget.disableTabs ? '' : _style2.default.tabs) },
			_react2.default.createElement('div', { className: _style2.default.hidden + ' ' + ((0, _utils.showTabContent)(props, _constants.SPECIALIST_REVIEWS_TAB) && _style2.default.specialistReviewsHolder || (0, _utils.showTabContent)(props, _constants.SPECIALIST_RECOMMENDATIONS_TAB) && _style2.default.specialistRecommendationsHolder) }),
			_react2.default.createElement(
				_reactTransitionGroup.Transition,
				{ 'in': (0, _utils.showTabContent)(props, _constants.SPECIALIST_REVIEWS_TAB), timeout: 500 },
				function (state) {
					return _react2.default.createElement(
						'div',
						{ style: (0, _utils.getTransition)(props)[state], className: '' + _style2.default.transition },
						_react2.default.createElement(
							_widgetCarousel.WidgetCarousel,
							{
								title: 'Reviews',
								isLoading: props.widget.isLoading,
								rowSize: (0, _utils.getRowSize)(props.widget && props.widget.layoutType),
								showNextButton: props.widget.specialist && props.carousel.specialistReviewsOffset < props.widget.specialist.numberOfReviews - _constants.CAROUSEL_LENGTH,
								showPreviousButton: props.carousel.specialistReviewsOffset > 0,
								onNextButtonClick: function onNextButtonClick() {
									props.carouselActions.updateOffset({ specialistReviewsOffset: props.carousel.specialistReviewsOffset + _constants.CAROUSEL_LENGTH });
									props.widgetActions.getSpecialistReviews(props.widget.specialist && props.widget.specialist.id, _constants.SPECIALIST_PROFILE_TYPE, {
										offset: props.carousel.specialistReviewsOffset + _constants.CAROUSEL_LENGTH,
										limit: _constants.CAROUSEL_LENGTH,
										min_rating: props.widget.minReviewRating
									});
								},
								onPreviousButtonClick: function onPreviousButtonClick() {
									props.carouselActions.updateOffset({ specialistReviewsOffset: props.carousel.specialistReviewsOffset - _constants.CAROUSEL_LENGTH });
									props.widgetActions.getSpecialistReviews(props.widget.specialist && props.widget.specialist.id, _constants.SPECIALIST_PROFILE_TYPE, {
										offset: props.carousel.specialistReviewsOffset - _constants.CAROUSEL_LENGTH,
										limit: _constants.CAROUSEL_LENGTH,
										min_rating: props.widget.minReviewRating
									});
								},
								profileType: 'specialist',
								contentType: 'reviews',
								averageRating: props.widget.specialist && props.widget.specialist.averageReviews,
								totalReviews: props.widget.specialist && props.widget.specialist.numberOfReviews
							},
							props.widget.specialistReviews && props.widget.specialistReviews.length ? props.widget.specialistReviews.map(function (review, index) {
								return _react2.default.createElement(
									'div',
									{ key: 'review-' + props.carousel.specialistReviewsOffset + '-' + index, style: dynamics.fadeIn },
									_react2.default.createElement(_review.Review, (0, _extends3.default)({
										disableLikeButton: true,
										className: '' + _style2.default.review,
										titleStyle: _style2.default.title,
										reviewContentStyle: _style2.default.reviewContent
									}, review))
								);
							}) : [_ref]
						)
					);
				}
			),
			_react2.default.createElement(
				_reactTransitionGroup.Transition,
				{ 'in': (0, _utils.showTabContent)(props, _constants.SPECIALIST_RECOMMENDATIONS_TAB), timeout: 500 },
				function (state) {
					return _react2.default.createElement(
						'div',
						{ style: (0, _utils.getTransition)(props)[state], className: '' + _style2.default.transition },
						_react2.default.createElement(
							_widgetCarousel.WidgetCarousel,
							{

								title: 'Recommendations',
								isLoading: props.widget.isLoading,
								rowSize: (0, _utils.getRowSize)(props.widget && props.widget.layoutType),
								showNextButton: props.widget.specialist && props.carousel.specialistRecommendationsOffset < props.widget.specialist.numberOfPeerRecommendations - _constants.CAROUSEL_LENGTH,
								showPreviousButton: props.carousel.specialistRecommendationsOffset > 0,
								onNextButtonClick: function onNextButtonClick() {
									props.carouselActions.updateOffset({ specialistRecommendationsOffset: props.carousel.specialistRecommendationsOffset + _constants.CAROUSEL_LENGTH });
									props.widgetActions.getSpecialistPeerRecommendations(props.widget.specialist && props.widget.specialist.id, _constants.SPECIALIST_PROFILE_TYPE, {
										offset: props.carousel.specialistRecommendationsOffset + _constants.CAROUSEL_LENGTH,
										limit: _constants.CAROUSEL_LENGTH
									});
								},
								onPreviousButtonClick: function onPreviousButtonClick() {
									props.carouselActions.updateOffset({ specialistRecommendationsOffset: props.carousel.specialistRecommendationsOffset - _constants.CAROUSEL_LENGTH });
									props.widgetActions.getSpecialistPeerRecommendations(props.widget.specialist && props.widget.specialist.id, _constants.SPECIALIST_PROFILE_TYPE, {
										offset: props.carousel.specialistRecommendationsOffset - _constants.CAROUSEL_LENGTH,
										limit: _constants.CAROUSEL_LENGTH
									});
								},
								profileType: 'specialist',
								contentType: 'recommendations',
								totalReviews: props.widget.specialist && props.widget.specialist.numberOfPeerRecommendations
							},
							props.widget.specialistRecommendations && props.widget.specialistRecommendations.length ? props.widget.specialistRecommendations.map(function (review, index) {
								return _react2.default.createElement(
									'div',
									{ key: 'recommendation-' + props.carousel.specialistRecommendationsOffset + '-' + index, style: dynamics.fadeIn },
									_react2.default.createElement(_peerRecommendation.PeerRecommendation, (0, _extends3.default)({
										className: '' + _style2.default.review,
										titleStyle: _style2.default.title,
										recommendationContentStyle: _style2.default.reviewContent
									}, review))
								);
							}) : [_ref2]
						)
					);
				}
			)
		)
	);
};

SpecialistReviewsContainer.propTypes = {
	testString: require('react').PropTypes.any,
	widget: require('react').PropTypes.shape({
		specialist: require('react').PropTypes.object,
		specialistReviews: require('react').PropTypes.arrayOf(require('react').PropTypes.object),
		specialistsReviews: require('react').PropTypes.arrayOf(require('react').PropTypes.object),
		specialistsPeerRecommendations: require('react').PropTypes.arrayOf(require('react').PropTypes.object),
		specialists: require('react').PropTypes.arrayOf(require('react').PropTypes.object).isRequired,
		layoutType: require('react').PropTypes.any
	}).isRequired,
	carousel: require('react').PropTypes.shape({
		selectedSpecialistId: require('react').PropTypes.any
	}).isRequired,
	header: require('react').PropTypes.shape({
		selectedTab: require('react').PropTypes.any.isRequired
	}).isRequired
};
SpecialistReviewsContainer.displayName = 'SpecialistReviewsContainer';

SpecialistReviewsContainer.defaultProps = {};